module.exports = __webpack_public_path__ + "static/mockapp-progress-ea2f3cb3a08a2445993d1e6d5231aeb2.png";